// Where a sign-in returns the player (design 16 J2): the page they were on rides in the address, through Google's round
// trip (the gateway keeps it with the pending sign-in) and in the email link, so every Sign in brings them back.

/** The sign-in page's address from the page the player is on. */
export function signInHref(): string {
  const here = location.pathname + location.search;
  return here === "/" || here.startsWith("/signin") ? "/signin" : `/signin?then=${encodeURIComponent(here)}`;
}

/** For a Sign in link: it leaves from wherever the page is by then (a replay's position, a table's state). */
export function toSignIn(e: MouseEvent) {
  (e.currentTarget as HTMLAnchorElement).href = signInHref();
}

/** Where a sign-in started on this page returns to: a path on this site, else Home. The gateway checks it again. */
export function returnTo(search = location.search): string {
  const then = new URLSearchParams(search).get("then") ?? "";
  return then.startsWith("/") && !then.startsWith("//") && !then.startsWith("/\\") ? then : "/";
}
